<div class="container mt-4">
  <div class="mb-2">
    <div class="topNavH"></div>
    <div class="text-end mb-3">
      <app-settings-offcanvas></app-settings-offcanvas>
    </div>
  </div>
  <h2 class="text-center mb-2 bigTitleCol">{{ 'SCHOOL_ENROLLMENT.PAGE_TITLE' | translate }}</h2>
  
  <form [formGroup]="schoolEnrollmentForm" (ngSubmit)="onSubmit()">
    <div class="card  shadow-sm">
      <div class="card-body">
      <p class="text-muted small">
        {{ 'SCHOOL_ENROLLMENT.PAGE_INFO' | translate }}

      </p>
        <div class="mb-3">
          <label for="organization" class="form-label">
            {{ 'SCHOOL_ENROLLMENT.ORGANISATION_CENTER_LABEL' | translate }}<span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" id="organization" formControlName="organization"
                 [ngClass]="{'is-invalid': schoolEnrollmentForm.get('organization')?.invalid && schoolEnrollmentForm.get('organization')?.touched}">
          <div *ngIf="schoolEnrollmentForm.get('organization')?.invalid && schoolEnrollmentForm.get('organization')?.touched" class="invalid-feedback">
            {{ 'SCHOOL_ENROLLMENT.ALL_MANDATORY_NOTE' | translate }}
          </div>
        </div>

        <div class="mb-3">
          <label for="address" class="form-label">
            {{ 'SCHOOL_ENROLLMENT.ADDRESS_LABEL' | translate }}<span class="text-danger">*</span>
          </label>
          <textarea class="form-control" id="address" formControlName="address" rows="3"
                    [ngClass]="{'is-invalid': schoolEnrollmentForm.get('address')?.invalid && schoolEnrollmentForm.get('address')?.touched}"></textarea>
          <div *ngIf="schoolEnrollmentForm.get('address')?.invalid && schoolEnrollmentForm.get('address')?.touched"
            class="invalid-feedback">
            {{ 'SCHOOL_ENROLLMENT.ALL_MANDATORY_NOTE' | translate }}
          </div>
        </div>

        <div class="mb-3">
          <label for="tel" class="form-label">
            {{ 'SCHOOL_ENROLLMENT.TEL_LABEL' | translate }}<span class="text-danger">*</span>
          </label>
          <input type="tel" class="form-control" id="tel" formControlName="tel"
                 [ngClass]="{'is-invalid': schoolEnrollmentForm.get('tel')?.invalid && schoolEnrollmentForm.get('tel')?.touched}">
          <div *ngIf="schoolEnrollmentForm.get('tel')?.invalid && schoolEnrollmentForm.get('tel')?.touched"
            class="invalid-feedback">
            {{ 'SCHOOL_ENROLLMENT.ALL_MANDATORY_NOTE' | translate }}
          </div>
        </div>

        <div class="mb-3">
          <label for="fax" class="form-label">{{ 'SCHOOL_ENROLLMENT.FAX_LABEL' | translate }}<span
              class="text-danger">*</span></label>
          <input type="tel" class="form-control" id="fax" formControlName="fax"
                 [ngClass]="{'is-invalid': schoolEnrollmentForm.get('fax')?.invalid && schoolEnrollmentForm.get('fax')?.touched}">
          <div *ngIf="schoolEnrollmentForm.get('fax')?.invalid && schoolEnrollmentForm.get('fax')?.touched"
            class="invalid-feedback">
            {{ 'SCHOOL_ENROLLMENT.ALL_MANDATORY_NOTE' | translate }}
          </div>
        </div>

        <div class="mb-3">
          <label for="contact_person" class="form-label">
            {{ 'SCHOOL_ENROLLMENT.CONTACT_PERSON_LABEL' | translate }}<span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" id="contact_person" formControlName="contact_person"
                 [ngClass]="{'is-invalid': schoolEnrollmentForm.get('contact_person')?.invalid && schoolEnrollmentForm.get('contact_person')?.touched}">
          <div
            *ngIf="schoolEnrollmentForm.get('contact_person')?.invalid && schoolEnrollmentForm.get('contact_person')?.touched"
            class="invalid-feedback">
            {{ 'SCHOOL_ENROLLMENT.ALL_MANDATORY_NOTE' | translate }}
          </div>
        </div>

        <div class="mb-3">
          <label for="email" class="form-label">
            {{ 'SCHOOL_ENROLLMENT.CONTACT_PERSON_EMAIL_LABEL' | translate }}<span class="text-danger">*</span>
          </label>
          <input type="email" class="form-control" id="email" formControlName="email"
                 [ngClass]="{'is-invalid': schoolEnrollmentForm.get('email')?.invalid && schoolEnrollmentForm.get('email')?.touched}">
          <div
            *ngIf="schoolEnrollmentForm.get('email')?.errors?.['required'] && schoolEnrollmentForm.get('email')?.touched"
            class="invalid-feedback">
            {{ 'SCHOOL_ENROLLMENT.ALL_MANDATORY_NOTE' | translate }}
          </div>
          <div
            *ngIf="schoolEnrollmentForm.get('email')?.errors?.['email'] && schoolEnrollmentForm.get('email')?.touched"
            class="invalid-feedback">
            {{ 'SCHOOL_ENROLLMENT.INVALID_EMAIL_FORMAT_NOTE' | translate }}
          </div>
        </div>

        <div class="mb-3">
          <label for="website" class="form-label">{{ 'SCHOOL_ENROLLMENT.WEBSITE_LABEL' | translate }}<span
              class="text-danger">*</span></label>
          <input type="url" class="form-control" id="website" formControlName="website"
                 [ngClass]="{'is-invalid': schoolEnrollmentForm.get('website')?.invalid && schoolEnrollmentForm.get('website')?.touched}">
          <div *ngIf="schoolEnrollmentForm.get('website')?.invalid && schoolEnrollmentForm.get('website')?.touched"
            class="invalid-feedback">
            {{ 'SCHOOL_ENROLLMENT.ALL_MANDATORY_NOTE' | translate }}
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label d-block mb-2">
            {{ 'SCHOOL_ENROLLMENT.MAIN_DISABILITIES_LABEL' | translate }}<span
            class="text-danger">*</span>
          </label>
          <p class="text-muted small">
            {{ 'SCHOOL_ENROLLMENT.MAX_WEIGHT_NOTE' | translate }}
          </p>

          <div class="mb-2" formGroupName="physically_challenged_group">
            <h5 class="mb-2 form-labelCe">{{ 'SCHOOL_ENROLLMENT.PHYSICALLY_CHALLENGED_TITLE' | translate }}</h5>
            <div *ngFor="let option of physicallyChallengedOptions" class="form-check">
              <input class="form-check-input" type="checkbox" [id]="option.key" [formControlName]="option.key">
              <label class="form-check-label" [for]="option.key">
                {{ option.labelKey | translate }}
              </label>
            </div>
            <!-- <div *ngIf="schoolEnrollmentForm.get('physically_challenged_group')?.errors?.['atLeastOneRequired'] && schoolEnrollmentForm.get('physically_challenged_group')?.touched" class="invalid-feedback d-block">
              {{ 'SCHOOL_ENROLLMENT.SELECT_AT_LEAST_ONE_DISABILITY_NOTE' | translate }}
            </div> -->
          </div>

          <div class="mb-3" formGroupName="intellectually_challenged_group">
            <h5 class="mb-2 form-label">{{ 'SCHOOL_ENROLLMENT.INTELLECTUALLY_CHALLENGED_TITLE' | translate }}</h5>
            <div *ngFor="let option of intellectuallyChallengedOptions" class="form-check">
              <input class="form-check-input" type="checkbox" [id]="option.key" [formControlName]="option.key">
              <label class="form-check-label" [for]="option.key">
                {{ option.labelKey | translate }}
              </label>
            </div>
            <!-- <div *ngIf="schoolEnrollmentForm.get('intellectually_challenged_group')?.errors?.['atLeastOneRequired'] && schoolEnrollmentForm.get('intellectually_challenged_group')?.touched" class="invalid-feedback d-block">
              {{ 'SCHOOL_ENROLLMENT.SELECT_AT_LEAST_ONE_DISABILITY_NOTE' | translate }}
            </div> -->
          </div>
          <div *ngIf="schoolEnrollmentForm.hasError('atLeastOneDisabilityRequired') && schoolEnrollmentForm.touched" class="invalid-feedback d-block">
            {{ 'SCHOOL_ENROLLMENT.SELECT_AT_LEAST_ONE_DISABILITY_NOTE' | translate }}
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label d-block mb-2">
            {{ 'SCHOOL_ENROLLMENT.AGE_RANGE_LABEL' | translate }}<span class="text-danger">*</span>
          </label>
          <p class="text-muted small ">
            {{ 'SCHOOL_ENROLLMENT.MIN_AGE_NOTE' | translate }}
          </p>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="age_range" id="primaryAgeRange" value="primary"
              formControlName="age_range">
            <label class="form-check-label" for="primaryAgeRange">
              {{ 'SCHOOL_ENROLLMENT.PRIMARY_AGE_RANGE' | translate }}
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="age_range" id="secondaryAgeRange" value="secondary"
              formControlName="age_range">
            <label class="form-check-label" for="secondaryAgeRange">
              {{ 'SCHOOL_ENROLLMENT.SECONDARY_AGE_RANGE' | translate }}
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="age_range" id="adultsAgeRange" value="adult"
              formControlName="age_range"> <label class="form-check-label" for="adultsAgeRange">
              {{ 'SCHOOL_ENROLLMENT.ADULTS_AGE_RANGE' | translate }}
            </label>
          </div>
          <div *ngIf="schoolEnrollmentForm.get('age_range')?.invalid && schoolEnrollmentForm.get('age_range')?.touched"
            class="text-danger small mt-1">
            {{ 'SCHOOL_ENROLLMENT.ALL_MANDATORY_NOTE' | translate }}
          </div>
        </div>
       
        <div class="">
          <!-- <h5 class="mb-2">{{ 'SCHOOL_ENROLLMENT.SCHOOL_TIME_PREFERENCE_TITLE' | translate }}</h5> -->
          <label class="form-label d-block mb-2">
            {{ 'SCHOOL_ENROLLMENT.SCHOOL_TIME_PREFERENCE_TITLE' | translate }}<span class="text-danger">*</span>
          </label>
          <p class="text-muted small">
            {{ 'SCHOOL_ENROLLMENT.SELECT_SCHOOL_TIME_PREFERENCE_NOTE' | translate }}
          </p>
          <div *ngFor="let group of groupedTimeslots" class="mb-3">
            <!-- <h6>{{ group.name }}</h6> -->
            <!-- <div class="text-muted small mb-2">
              {{ 'SCHOOL_ENROLLMENT.COMMENCEMENT_DATE_LABEL' | translate }}: xxXXX
            </div> -->
            <ng-container [ngSwitch]="group.venue_id">
              <ng-container *ngSwitchCase="1">
                <h6>{{ 'SCHOOL_ENROLLMENT.VENUE_1_NAME' | translate }}</h6>
                <div class="text-muted small mb-2">
                  {{ 'SCHOOL_ENROLLMENT.VENUE_1_ADDRESS_LABEL' | translate }} {{ 'SCHOOL_ENROLLMENT.VENUE_1_ADDRESS_VALUE' | translate }}
                </div>
                <div class="text-muted small mb-2">
                  {{ 'SCHOOL_ENROLLMENT.VENUE_1_TEL_LABEL' | translate }} {{ 'SCHOOL_ENROLLMENT.VENUE_1_TEL_VALUE' | translate }}
                </div>
              </ng-container>
            
              <ng-container *ngSwitchCase="2">
                <h6>{{ 'SCHOOL_ENROLLMENT.VENUE_2_NAME' | translate }}</h6>
                <div class="text-muted small mb-2">
                  {{ 'SCHOOL_ENROLLMENT.VENUE_2_ADDRESS_LABEL' | translate }} {{ 'SCHOOL_ENROLLMENT.VENUE_2_ADDRESS_VALUE' | translate }}
                </div>
                <div class="text-muted small mb-2" ng-if="SCHOOL_ENROLLMENT.VENUE_2_TEL_VALUE">
                  {{ 'SCHOOL_ENROLLMENT.VENUE_2_TEL_LABEL' | translate }} {{ 'SCHOOL_ENROLLMENT.VENUE_2_TEL_VALUE' | translate }}
                </div>
              </ng-container>
            
              <ng-container *ngSwitchCase="3">
                <h6>{{ 'SCHOOL_ENROLLMENT.VENUE_3_NAME' | translate }}</h6>
                <div class="text-muted small mb-2">
                  {{ 'SCHOOL_ENROLLMENT.VENUE_3_ADDRESS_LABEL' | translate }} {{ 'SCHOOL_ENROLLMENT.VENUE_3_ADDRESS_VALUE' | translate }}
                </div>
              </ng-container>
            
              <ng-container *ngSwitchDefault>
                <h6>{{ group.name }}</h6>
              </ng-container>
            </ng-container>
            <div class="row header-row g-0 fw-bold small text-muted border-bottom pb-1 mb-2">
              <div class="col-6">{{ 'DAYS.TITLE' | translate }}</div>
              <div class="col-6">{{ 'TIMESLOTS.TITLE' | translate }}</div>
            </div>

            <ng-container *ngFor="let timeslot of group.timeslots; let i = index">
              <div class="row g-0 align-items-center py-1"
                [ngClass]="{'border-bottom': i === group.timeslots.length - 1 || timeslot.weekday !== group.timeslots[i + 1].weekday}">

                <div class="col-5 d-flex align-items-center">
                  <div class="" style="margin-bottom: 8%;">
                    <ng-container *ngIf="isFirstTimeslotOfDay(timeslot, group.timeslots)">
                      {{ getWeekdayLabel(timeslot.weekday) | translate }}
                    </ng-container>
                  </div>
                </div>

                <div class="col-7 d-flex align-items-center">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [id]="'timeslot-' + timeslot.id"
                      [value]="timeslot.id" [checked]="hasTimeslot(timeslot.id)"
                      (change)="onTimeslotToggle($event, timeslot.id)">
                    <label class="form-check-label" [for]="'timeslot-' + timeslot.id">
                      {{ timeslot.label }}
                    </label>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>


        <div class="d-grid gap-2 mt-4">
          <button type="submit" class="btn button-primary-purple me-2">
            {{ 'SCHOOL_ENROLLMENT.SUBMIT_BUTTON' | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>

  <div class="modal fade" [ngClass]="{'show d-block': showPreview, 'd-none': !showPreview}" tabindex="-1" role="dialog" aria-labelledby="previewModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg " role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="previewModalLabel">{{ 'ADD_STUDENT.PREVIEW.TITLE' | translate }}</h5>
          <button type="button" class="btn-close" (click)="closePreview()" aria-label="Close"></button>
        </div>
        <div class="modal-body" style="max-height: 65vh; overflow-y: auto;">
          <p><strong>{{ 'SCHOOL_ENROLLMENT.ORGANISATION_CENTER_LABEL' | translate }}:</strong> {{ getFormControlValue('organization') }}</p>
          <p><strong>{{ 'SCHOOL_ENROLLMENT.ADDRESS_LABEL' | translate }}:</strong> {{ getFormControlValue('address') }}</p>
          <p><strong>{{ 'SCHOOL_ENROLLMENT.TEL_LABEL' | translate }}:</strong> {{ getFormControlValue('tel') }}</p>
          <p><strong>{{ 'SCHOOL_ENROLLMENT.FAX_LABEL' | translate }}:</strong> {{ getFormControlValue('fax') }}</p>
          <p><strong>{{ 'SCHOOL_ENROLLMENT.CONTACT_PERSON_LABEL' | translate }}:</strong> {{ getFormControlValue('contact_person') }}</p>
          <p><strong>{{ 'SCHOOL_ENROLLMENT.CONTACT_PERSON_EMAIL_LABEL' | translate }}:</strong> {{ getFormControlValue('email') }}</p>
          <p><strong>{{ 'SCHOOL_ENROLLMENT.WEBSITE_LABEL' | translate }}:</strong> {{ getFormControlValue('website') }}</p>
          
          <p><strong>{{ 'SCHOOL_ENROLLMENT.MAIN_DISABILITIES_LABEL' | translate }}:</strong></p>
          <ul>
            <li *ngFor="let disability of getSelectedPhysicallyChallengedLabels()">{{ disability }}</li>
            <li *ngFor="let disability of getSelectedIntellectuallyChallengedLabels()">{{ disability }}</li>
            <li *ngIf="!getSelectedPhysicallyChallengedLabels().length && !getSelectedIntellectuallyChallengedLabels().length" class="text-muted small">
              {{ 'SCHOOL_ENROLLMENT.NO_DISABILITIES_SELECTED' | translate }}
            </li>
          </ul>
          <p><strong>{{ 'SCHOOL_ENROLLMENT.AGE_RANGE_LABEL' | translate }}:</strong>
            {{ ('SCHOOL_ENROLLMENT.' + getFormControlValue('age_range')?.toUpperCase() + '_AGE_RANGE' | translate) || getFormControlValue('age_range') }}
          </p>
          <strong>{{ 'SCHOOL_ENROLLMENT.SELECTED_TIMESLOTS_TITLE' | translate }}:</strong>
          
          <div *ngIf="prefer_timeslots.value.length > 0; else noTimeslotsSelected" class="mt-2">
            <div *ngFor="let venue of selectedVenueDetails" class="mb-3">
              <strong>{{ venue.nameKey | translate }}</strong>
              <ul class="list-unstyled ps-3 mt-1">
                <li *ngFor="let time of venue.selectedTimes">
                  • {{ time.weekday }} {{ time.label }}
                </li>
              </ul>
            </div>
          </div>

          <ng-template #noTimeslotsSelected>
            <p class="text-muted small mt-1">
              {{ 'SCHOOL_ENROLLMENT.NO_TIMESLOTS_SELECTED_NOTE' | translate }}
            </p>
          </ng-template>



        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closePreview()">
            {{ 'ADD_STUDENT.PREVIEW.CANCEL_BUTTON' | translate }}
          </button>
          <button type="button" class="btn button-primary-purple" (click)="submitApplication()">
            {{ 'ADD_STUDENT.PREVIEW.CONFIRM_BUTTON' | translate }}
          </button> 
        </div>
      </div>
    </div>
  </div>
  <div style="height: 70px;"></div>
  <div class="modal-backdrop fade show" *ngIf="showPreview" style="z-index: 1050;"></div>
</div>